import React, { useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './headerStyle.css'

//Import IMAGES
import LOGO from '../../Assets/images/FInEra_LOGO.png'
import LOGODARK from '../../Assets/images/FinEra_LOGO_Darkmode.png'

//Importing Components
import DMLM_Button from '../DMLM_Button/DMLM_Button'

//Importing GSAP for Animation
import gsap from 'gsap'; // <-- import GSAP
import { useGSAP } from '@gsap/react'; // <-- import the hook from our React package

gsap.registerPlugin(useGSAP)

function Header({ states, toggleModes }) {
    //Refs
    const container = useRef(null)

    //Route
    const route = useLocation()

    useGSAP(
        () => {
            // gsap code here...
            const tl = gsap.timeline()
            tl.from('.logo_container', { x: -80, opacity: 0, duration: 0.5, delay: 0.3, });
            tl.from('.navbar_container ul li', { x: 80, opacity: 0, duration: 0.5, stagger: -0.1 }) // <-- automatically reverted
        },
        { scope: container }
    ); // <-- scope for selector text (optional)

    //States
    const [navbarDisplay, setnavbarDisplay] = useState(false)
    const [headerChange, setheaderChange] = useState(false)

    //functions
    const handleNavbarDisplay = () => {
        if (navbarDisplay) {
            setnavbarDisplay(false)
            //UnLock Scroll
            document.body.style.overflow = '';
        } else {
            setnavbarDisplay(true)
            //Lock Scroll
            document.body.style.overflow = 'hidden';
        }
    }

    const handleHeaderChange = () => {
        if (route.pathname === "/") {
            if (window.scrollY >= (window.innerHeight - 65)) {
                setheaderChange(true)
            } else {
                setheaderChange(false)
            }
        } else if (route.pathname === "/aboutus") {
            if (window.scrollY >= (window.innerHeight - 65)) {
                setheaderChange(true)
            } else {
                setheaderChange(false)
            }
        } else {
            setheaderChange(false)
        }
    }

    window.addEventListener('scroll', handleHeaderChange)


    return (
        <>
            <div ref={container} className={[headerChange ? `header_container changed` : toggleModes.state == "light" ? `header_container` : `header_container dark`]}>
                <div className="logo_container">
                    <Link onClick={() => { states('.newBannerContainer') }} className="" to="/"><img src={headerChange ? LOGODARK : toggleModes.state == "light" ? LOGO : LOGODARK} /></Link>
                    {/* <button className=""><span className="bar1" /> <span className="" /> <span className="" /></button> */}
                </div>

                <div onClick={handleNavbarDisplay} className={navbarDisplay ? 'navbar_button_container active' : 'navbar_button_container'}>
                    <span className='line1'></span>
                    <span className='line2'></span>
                    <span className='line3'></span>
                </div>

                <div className={navbarDisplay ? "sidenavbar_container active" : "sidenavbar_container"} >
                    <ul>
                        <li><Link onClick={() => { states('.newBannerContainer'); handleNavbarDisplay() }} className="" to="/">Home</Link></li>
                        <li><Link onClick={handleNavbarDisplay} className="" to="/services&pricing">Services</Link></li>
                        {/* <li><Link onClick={() => { states('#pricing'); handleNavbarDisplay() }} className="" to="/">Pricing</Link></li> */}
                        <li><Link onClick={() => { states('.faq_section'); handleNavbarDisplay() }} className="" to="/">FAQ's</Link></li>
                        <li><Link onClick={() => { states('#contact'); handleNavbarDisplay() }} className="" to="/">Contact</Link></li>
                        <li><Link onClick={handleNavbarDisplay} className="" to="/aboutus">About</Link></li>
                        {/* <li><Link onClick={() => { states('#about'); handleNavbarDisplay() }} className="" to="/">About</Link></li> */}
                    </ul>

                    <DMLM_Button toggleModes={toggleModes}></DMLM_Button>
                </div>

                <div className={"navbar_container"} >
                    <ul>
                        <li><Link onClick={() => { states('.newBannerContainer') }} className="" to="/">Home</Link></li>
                        <li><Link className="" to="/services&pricing">Services</Link></li>
                        {/* <li><Link onClick={() => { states('#pricing') }} className="" to="/">Pricing</Link></li> */}
                        <li><Link onClick={() => { states('.faq_section') }} className="" to="/">FAQ's</Link></li>
                        <li><Link onClick={() => { states('#contact') }} className="" to="/">Contact</Link></li>
                        <li><Link className="" to="/aboutus">About</Link></li>
                        {/* <li><Link onClick={() => { states('#about') }} className="" to="/">About</Link></li> */}
                    </ul>
                    <DMLM_Button toggleModes={toggleModes}></DMLM_Button>
                </div>
            </div>
        </>
    )
}

export default Header